import React from 'react'
import {connect} from 'react-redux'
import '../assets/css/mainView.scss'
import {fetchMatches} from '../store/actions'
import BetGroup from '../Components/BetGroup'
import {ReactComponent as Refresh} from '../assets/icons/refresh.svg'
const MainView = props => {
  return (
    <div className="mainview">
      <div className="mainview__top">
        <div className="latest">
          <span className="circle"></span>
          <h1 className='hhad'>แทงบอล ฟรีเครดิต 15,000<br/><span className='hhs'>(ทดสอบโปรแกรม) สมัครโดยใช้อีเมล์อะไรก็ได้ ตัวอย่าง sd@sd.cc</span></h1>
        </div>
        <div className="refresh">
          <span>Refresh</span>
          <Refresh />
        </div>
      </div>
      <div className="mainview__matches">
        <BetGroup matches={props.matches} />
      </div>
      <a href="https://google.com/url?sa=t&url=https://ราคา.net/">แทงบอล</a> <a href="https://google.co.th/url?sa=t&url=https://ราคา.net/">ฟรีเครดิต</a>
    </div>
  )
}

//this guy would merge the redux state to the component's prop
const mapStateToProps = state => {
  // console.log("moprps", state.posts)
  return {matches: state.matches}
}
//so by passing the action creator to the connet method, anytime the method is called, the action gets dispatched
//automatically
export default connect(mapStateToProps, {fetchMatches})(MainView)
